/**
 * Stable CSS class names for E2E — RPA request report list.
 */
export const RPRL = {
    root: 'rpa-request-list',

    headerPaper: 'rpa-request-list__header-paper',
    headerTableWrap: 'rpa-request-list__header-table-wrap',
    headerTable: 'rpa-request-list__header-table',
    headerTableHead: 'rpa-request-list__header-table-head',
    headerRow: 'rpa-request-list__header-row',
    headerCellId: 'rpa-request-list__header-cell--id',
    headerCellDate: 'rpa-request-list__header-cell--date',
    headerCellPerson: 'rpa-request-list__header-cell--person',
    headerCellStatus: 'rpa-request-list__header-cell--status',

    rowPaper: 'rpa-request-list__row-paper',
    rowTableWrap: 'rpa-request-list__row-table-wrap',
    rowTable: 'rpa-request-list__row-table',
    rowBody: 'rpa-request-list__row-body',
    row: 'rpa-request-list__row',
    cellId: 'rpa-request-list__cell--id',
    cellDate: 'rpa-request-list__cell--date',
    cellPerson: 'rpa-request-list__cell--person',
    cellStatus: 'rpa-request-list__cell--status',

    dateTooltip: 'rpa-request-list__date-tooltip',

    statusChipWaiting: 'rpa-request-list__status-chip--waiting',
    statusChipCompleted: 'rpa-request-list__status-chip--completed',
    statusChipOther: 'rpa-request-list__status-chip--other',
} as const;

export const rprlCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

